import React from 'react';
import Row from './Row';

const SemesterTranscript = (props) => {
    const { item } = props
    return (
            
            



            <div class="panel  panel-default " >
  <div class="panel-heading">
    <div class="panel-heading-btn">
      
      
    </div>
    <h4 class="panel-title text-center text-primecolor">{item.batchName}</h4>
  </div>
  <div class="panel-body">
   
        
    <table class="gv gv_transcript">
                <tbody>
                    <tr>
                        <th scope="col">Course Code</th>
                        <th scope="col">Course Name</th>
                        <th scope="col">Credit Hours</th>
                        <th scope="col">Grade</th>
                        <th scope="col">Points</th>
                        <th scope="col">Credit Achevied</th>
                        <th scope="col">GPA</th>


                    </tr>

                    {item.courses.map(i => <Row item={i} key={i.crsnum} />)}
                    <tr class="gv_footer">

                    </tr>
                    <tr class="gv_footer">
                        <td colspan="2">Semester Achievements</td>
                        <td>{item.creditAchieved}</td>

                        <td> </td>
                        <td>{item.points}</td>
                        <td></td>
                        <td>{item.gpa}</td>
                    </tr>


                </tbody>
            </table>





  </div>
</div>



           
    );
};

export default SemesterTranscript;


// WEBPACK FOOTER //
// ./src/pages/Transcript/SemesterTranscript.js